import React, {
    useEffect,
    useState,
    useContext,
    useRef,
    forwardRef,
    useImperativeHandle,
} from "react";
import {
    Row,
    Col,
    Form,
    Button,
    Modal,
    Tabs,
    message
} from "../../ui/ot";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import JoditEditor from "jodit-react";
import DocumentManagementForm from "./document_management_form";
import { useFileType } from "../controllers/file_type_controller";
import { useDocument } from "../controllers/document_controller";
import EditorSpreadsheet from "../../controls/EditorSpreadsheet";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import ImageCrop from "./ImageCrop";


const DocumentManagementModal = forwardRef(
    (
        {
            axiosMethod = "post",
            showOpenButton = false,
            openButtonText = "打開",
            onFinish = () => { },
            axiosMode = "post",
            propsForm,
            propsOpen = null,
            propsLoading = null,
            propsSetOpen = () => { },
        },
        ref
    ) => {
        const axiosModelanguage = {
            post: "新增",
            patch: "修改",
        };
        const [form] = Form.useForm();
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [loading, setLoading] = useState(false);
        const [formReloadCount, setFormReloadCount] = useState(0);
        const showModal = () => {
            setFormReloadCount((pre) => pre + 1);
            if (propsOpen === null) {
                setIsModalOpen(true);
            } else {
                propsSetOpen(true);
            }
        };
        const closeModal = () => {
            if (propsOpen === null) {
                setIsModalOpen(false);
            } else {
                propsSetOpen(false);
            }
        };

        const handleOk = () => {
            setLoading(true);
            if (propsForm) {
                propsForm.submit();
            } else {
                form.submit();
            }
        };

        const handleCancel = () => {
            closeModal();
        };
        const onFormFinish = (values) => {
            onFinish(values);
        };

        const getAnyFormValue = (name, count) => {
            let formValues = null;
            if (propsForm) {
                if (name) {
                    formValues = propsForm.getFieldValue(name);
                }
                else {
                    formValues = propsForm.getFieldsValue();
                }
            } else {
                if (name) {
                    formValues = form.getFieldValue(name);
                }
                else {
                    formValues = form.getFieldsValue();
                }
            }
            return formValues;
        };



        return (
            <Row>
                <Col>
                    {propsOpen === null && (
                        <Button type="primary" onClick={showModal}>
                            {`${openButtonText}`}
                        </Button>
                    )}
                </Col>
                <Col>
                    <Modal
                        title={`${axiosModelanguage[axiosMode]}${openButtonText}`}
                        open={propsOpen === null ? isModalOpen : propsOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        confirmLoading={propsLoading === null ? loading : propsLoading}
                        maskClosable={false}
                        width={1000}
                        contentStyle={{
                            padding: 16,
                        }}
                        okText={'儲存'}
                        cancelText={'取消'}
                    >
                        <Row>
                            <Col span={24}>
                                <DocumentManagementForm
                                    formReloadCount={formReloadCount}
                                    open={propsOpen === null ? isModalOpen : propsOpen}
                                    axiosMode={axiosMode}
                                    propsForm={propsForm ? propsForm : form}
                                    onFormFinish={onFormFinish}
                                />
                            </Col>
                            <Col span={24}>
                                <FilePreviewAndEdit
                                    data={getAnyFormValue(null, formReloadCount)}
                                />
                            </Col>
                        </Row>
                    </Modal>
                </Col>
            </Row>
        );
    }
);
const FilePreviewAndEdit = ({
    data
}) => {
    const editor = useRef(null);
    const [tabValue, setTabValue] = useState("preview")
    const [url, setUrl] = useState(null);
    const [dataurl, setDataUrl] = useState(null);
    const [content, setContent] = useState()
    const {
        getFileTypeData,
        FileTypeData
    } = useFileType({

    })
    const {
        downloadDocumentData,
        getDocumentFile,
        getWord,
        editWord
    } = useDocument({
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success("新增成功");
                } else if (axiosMode === "patch") {
                    message.success("修改成功");
                } else if (axiosMode === "delete") {
                    message.success("刪除成功");
                }
                else if (axiosMode === "delete") {
                    message.success("刪除成功");
                }
                else if (axiosMode === "editWord") {
                    message.success("檔案修改成功");
                }
            } else if (status === "error") {
                if (axiosMode === "post") {
                    message.error("新增失敗");
                } else if (axiosMode === "patch") {
                    message.error("修改失敗");
                } else if (axiosMode === "delete") {
                    message.error("刪除失敗");
                }
                else if (axiosMode === "editWord") {
                    message.success("檔案修改失敗");
                }
            }
        }
    })
    const handleDownload = (file_id, file_client_name) => {
        // console.log(props.file);
        // console.log(props.file.file_id);
        downloadDocumentData(
            file_id, file_client_name
        )

    }
    useEffect(() => {
        getFileTypeData({})
    }, [])
    useEffect(() => {
        let file_client_name = data?.file_client_name || ""
        let str = file_client_name.split(".");
        let file_extension_tmp = `${str.at(-1)}`;
        if (data?.file_id) {
            getDocumentFile(data?.file_id)
                .then((response) => {
                    var blob_ = new Blob([response], {
                    });
                    // console.log(blob_);
                    var reader = new FileReader();
                    reader.readAsDataURL(blob_);
                    reader.onloadend = function () {
                        var base64String = reader.result;
                        setUrl(base64String);
                    };
                    const dataurl = URL.createObjectURL(blob_);
                    setDataUrl(dataurl);
                })
            if (file_extension_tmp === "docx" || file_extension_tmp === "doc") {
                getWord(data?.file_id)
                    .then((res) => {
                        setContent(res)
                        document.body.style['pointer-events'] = "auto";
                    })
            }
        }
    }, [data])
    return (
        <Row>
            {<Col span={24}>
                {
                    (FileTypeData || []).map((fileType) => {
                        return <Col span={24}>
                            {
                                parseInt(data?.file_type_id) === fileType?.file_type_id &&
                                <Row gutter={[8, 8]}>

                                    {/* 圖片編輯 */}
                                    <Col span={24}>
                                        {
                                            fileType?.file_extension === "jpg|jpeg|png|gif|bmp|svg" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                    {
                                                                        key: "edit",
                                                                        tab: "編輯"
                                                                    }
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Button onClick={() => {
                                                                handleDownload(data?.file_id, data?.file_client_name)
                                                            }} >
                                                                下載
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>
                                                                <img width={'100%'} height={'auto'} src={url}></img>

                                                            </Col>
                                                        </Row>}
                                                    {tabValue === "edit" && <Row>
                                                        <Col span={24}>
                                                            <ImageCrop
                                                                width="500px"
                                                                setting={{
                                                                    upload: false,
                                                                    defaultImg: false,
                                                                }}
                                                                defaultSrc={url}
                                                                fileClientName={data?.file_client_name}
                                                                onCropComplete={(
                                                                    value
                                                                ) => {
                                                                    console.log({ value })

                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* PDF編輯 */}
                                        {
                                            fileType?.file_extension === "pdf" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                    // {
                                                                    //     key: "edit",
                                                                    //     tab: "編輯"
                                                                    // }
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Button onClick={() => {
                                                                handleDownload(data?.file_id, data?.file_client_name)
                                                            }} >
                                                                下載
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>
                                                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.js">
                                                                    <Viewer
                                                                        fileUrl={`${url}`}
                                                                    // plugins={[
                                                                    //     defaultLayoutPluginInstance,
                                                                    // ]}
                                                                    />
                                                                </Worker>
                                                            </Col>
                                                        </Row>}
                                                    {tabValue === "edit" && <Row>
                                                        <Col span={24}>
                                                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.js">
                                                                <Viewer
                                                                    fileUrl={`${url}`}
                                                                // plugins={[
                                                                //     defaultLayoutPluginInstance,
                                                                // ]}
                                                                />
                                                            </Worker>
                                                        </Col>
                                                    </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* excel 編輯 */}
                                        {
                                            fileType?.file_extension === "xls|xlsx|csv|ods" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                    {
                                                                        key: "edit",
                                                                        tab: "編輯"
                                                                    }
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Button onClick={() => {
                                                                handleDownload(data?.file_id, data?.file_client_name)
                                                            }} >
                                                                下載
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}
                                                                style={{
                                                                    maxWidth: "1150px",
                                                                    overflowX: "scroll",
                                                                }}

                                                            >
                                                                <EditorSpreadsheet
                                                                    mode={"read"}
                                                                    file_id={data?.file_id}
                                                                    file={data}
                                                                />
                                                            </Col>
                                                        </Row>}
                                                    {tabValue === "edit" && <Row>
                                                        <Col span={24}
                                                            style={{ maxWidth: "1150px", overflowX: "scroll" }}

                                                        >
                                                            <EditorSpreadsheet
                                                                mode={"edit"}
                                                                file_id={data?.file_id}
                                                                file={data}
                                                            />
                                                        </Col>
                                                    </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* docx 編輯 */}
                                        {
                                            fileType?.file_extension === "doc|docx|txt|rtf|odt" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                    {
                                                                        key: "edit",
                                                                        tab: "編輯"
                                                                    }
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Row gutter={[4, 4]}>
                                                                {tabValue === "edit" && <Col>
                                                                    <Button onClick={() => {
                                                                        editWord(data?.file_id, content)
                                                                    }} >
                                                                        儲存變更
                                                                    </Button>
                                                                </Col>}
                                                                <Col>
                                                                    <Button onClick={() => {
                                                                        handleDownload(data?.file_id, data?.file_client_name)
                                                                    }} >
                                                                        下載
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>

                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: content,
                                                                    }}
                                                                ></span>
                                                            </Col>
                                                        </Row>}
                                                    {tabValue === "edit" && <Row>
                                                        <Col span={24}

                                                        >
                                                            <JoditEditor
                                                                ref={editor}
                                                                value={content}
                                                                config={{
                                                                    readonly: false, // all options from https://xdsoft.net/jodit/doc/
                                                                    uploader: {
                                                                        insertImageAsBase64URI: true,
                                                                        // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
                                                                    },
                                                                    language: "zh_tw",
                                                                }}
                                                                tabIndex={1} // tabIndex of textarea
                                                                onBlur={(content) =>
                                                                    setContent(content)
                                                                } // preferred to use only this option to update the content for performance reasons
                                                                height={'auto'}
                                                                allowResizeX={true}
                                                                allowResizeY={true}
                                                            />
                                                        </Col>
                                                    </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* video 編輯 */}
                                        {
                                            fileType?.file_extension === "mp4|avi|mkv|mov|wmv" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Row gutter={[4, 4]}>
                                                                <Col>
                                                                    <Button onClick={() => {
                                                                        handleDownload(data?.file_id, data?.file_client_name)
                                                                    }} >
                                                                        下載
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>
                                                                <video
                                                                    className="VideoInput_video"
                                                                    width="100%"
                                                                    controls
                                                                    src={dataurl}
                                                                />
                                                            </Col>
                                                        </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* audio 編輯 */}
                                        {
                                            fileType?.file_extension === "mp3|wav|flac|aac|ogg" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Row gutter={[4, 4]}>
                                                                <Col>
                                                                    <Button onClick={() => {
                                                                        handleDownload(data?.file_id, data?.file_client_name)
                                                                    }} >
                                                                        下載
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>
                                                                <audio src={dataurl} controls />

                                                            </Col>
                                                        </Row>}
                                                </Col>
                                            </Row>
                                        }
                                        {/* ppt 編輯 */}
                                        {
                                            fileType?.file_extension === "ppt|pptx|odp" &&
                                            <Row>
                                                <Col span={24}>
                                                    <Row justify={"space-between"}>
                                                        <Col>
                                                            <Tabs
                                                                defaultActiveKey={tabValue}
                                                                key={fileType?.file_type_id}
                                                                activeKey={tabValue}
                                                                items={[
                                                                    {
                                                                        key: "preview",
                                                                        tab: "預覽"
                                                                    },
                                                                ]}
                                                                onChange={(value) => {
                                                                    setTabValue(value)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col>
                                                            <Row gutter={[4, 4]}>
                                                                <Col>
                                                                    <Button onClick={() => {
                                                                        handleDownload(data?.file_id, data?.file_client_name)
                                                                    }} >
                                                                        下載
                                                                    </Button>
                                                                </Col>
                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={24}>
                                                    {tabValue === "preview" &&
                                                        <Row>
                                                            <Col span={24}>
                                                                {url && <DocViewer
                                                                    pluginRenderers={DocViewerRenderers}
                                                                    documents={[
                                                                        { uri: url },
                                                                    ]}
                                                                />}
                                                            </Col>
                                                        </Row>}
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                </Row>}
                        </Col>
                    })
                }
            </Col>}
        </Row>
    )
}
export default DocumentManagementModal;
